<template>
    <div class="d-flex flex-wrap">
        <div class="col-12">
            <DataTable :date="selectedDate" :tbody="payments" @filterByDate="filterByDate" @getReceipt="getReceipt" v-if="!loader && payments"/>
        </div>
    </div>
    <transition name="fade-modal">
        <modal v-if="receipt" @close="receipt = null">
            <template v-slot:body>
                <div class="d-flex justify-content-center flex-wrap p-4 border rounded-4 shadow-lg bg-white">
                    <div class="receipt col-12 p-4 rounded-4 bg-white" id="receipt">
                        <div class="d-flex align-items-center flex-wrap">
                            <div class="col-12 col-md-6 text-center">
                                <img :src="require(`@/assets/img/tenants/${omsApiKey}/${omsApiKey}.png`)" class="w-50">
                            </div>
                            <div class="col-12 col-md-6 d-flex justify-content-center align-items-end flex-wrap font-monospace my-4">
                                <h4 class="text-third fw-bold">
                                    {{ $t('Dashboard.Payments.Modals.PaymentReceipt.labels.receipt') }} n.
                                </h4>
                                <span class="border border-second text-second fs-4 ms-2 p-2">
                                    {{ receipt.payment.short_id }}
                                </span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div class="col-12 d-flex flex-wrap my-4">
                                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center flex-wrap">
                                    <h3 class="text-third fw-bold">
                                        {{ account.name }} {{ account.surname }}
                                    </h3>
                                </div>
                                <div class="col-12 col-md-6 d-flex justify-content-center align-items-center flex-wrap">
                                    <img :src="require(`@/assets/img/card_schemes/${this.$formatLabel(receipt.bank_card.label)}.svg`)" class="card-scheme">
                                    <span class="text-second fs-4">
                                        {{ receipt.bank_card.truncated_pan }}
                                        <i class="fa-solid fa-mobile-screen-button fs-2 ms-2 text-third" v-if="receipt.bank_card.form_factor === 'DEVICE'"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 table-responsive mb-4">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th class="text-center text-nowrap">
                                                <i class="fa-solid fa-book-atlas me-2"></i>
                                                {{ $t('Dashboard.Payments.Modals.PaymentReceipt.labels.fare') }}
                                            </th>
                                            <th class="text-center text-nowrap">
                                                <i class="fa-solid fa-clock me-2"></i>
                                                {{ $t('Dashboard.Payments.Modals.PaymentReceipt.labels.valid_from') }}
                                            </th>
                                            <th class="text-center text-nowrap">
                                                <i class="fa-solid fa-clock me-2"></i>
                                                {{ $t('Dashboard.Payments.Modals.PaymentReceipt.labels.valid_to') }}
                                            </th>
                                            <th class="text-center text-nowrap">
                                                <i class="fa-solid fa-money-bill-1-wave me-2"></i>
                                                {{ $t('Dashboard.Payments.Modals.PaymentReceipt.labels.amount') }}
                                            </th>
                                            <th class="text-center text-nowrap">
                                                <i class="fa-solid fa-location-dot"></i>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(ticket, index) in receipt.tickets" :key="index" class="font-monospace">
                                            <td class="text-center align-middle">
                                                {{ ticket.fare_name }}
                                                <br>
                                                <span class="fw-bold">
                                                    {{ this.$formatAmount(ticket.fare_amount, receipt.payment.currencies_code) }}
                                                </span>
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ this.$formatDate(ticket.valid_from, this.account.locales_id, ticket.time_zone) }}
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ this.$formatDate(ticket.valid_to, this.account.locales_id, ticket.time_zone) }}
                                            </td>
                                            <td class="text-center align-middle">
                                                <span class="fw-bold">
                                                    {{ this.$formatAmount(ticket.ticket_amount, receipt.payment.currencies_code) }}
                                                </span>
                                            </td>
                                            <td class="text-center align-middle">
                                                <span v-for="(transit_data, index) in ticket.first_validation_transit_data" :key="index">
                                                    <span class="badge rounded bg-third">
                                                        {{ transit_data.key }}
                                                    </span>
                                                    <span class="badge rounded bg-second ms-2">
                                                        {{ transit_data.val }}
                                                    </span>
                                                </span>
                                                <h6 v-if="ticket.last_validation_transit_data && ticket.last_validation_transit_data.length > 0">
                                                - - - - - -
                                                </h6>
                                                <span v-for="(transit_data, index) in ticket.last_validation_transit_data" :key="index">
                                                    <span class="badge rounded bg-third">
                                                        {{ transit_data.key }}
                                                    </span>
                                                    <span class="badge rounded bg-second ms-2">
                                                        {{ transit_data.val }}
                                                    </span>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between align-items-center flex-wrap">
                        <span class="btn btn-auth btn-auth-white" @click="receipt = null">
                            {{ $t('Dashboard.Payments.Modals.PaymentReceipt.close_receipt') }}
                        </span>
                        <span class="btn btn-auth btn-auth-second" @click="downloadReceipt">
                            <i class="fa-solid fa-download me-2"></i>
                            {{ $t('Dashboard.Payments.Modals.PaymentReceipt.download') }}
                        </span>
                    </div>
                </div>
            </template>
        </modal>
    </transition>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import html2pdf from "html2pdf.js"
import DataTable from "@/components/DataTables/PaymentsDataTable.vue"
import Modal from '@/components/Modal.vue'
export default {
    name: 'PaymentsView',
    components: {
        DataTable,
        Modal
    },
    computed: {
        ...mapState(['loader', 'account']),
        ...mapGetters(['apiPath', 'omsApiPath', 'omsApiKey'])
    },
    data() {
        return {
            payments: null,
            total_pending_payments_amount: null,
            selectedDate: null,
            succeeded: true,
            failed: true,
            receipt: null
        }
    },
    methods: {
        ...mapMutations(['setLoader', 'setErrorFromServer']),
        getPayments(startDate, endDate, succeeded, failed) {
            this.setLoader(true)
            if (!startDate && !endDate) {
                startDate = moment().subtract(29, 'days').format('YYYY-MM-DD')
                endDate = moment().format('YYYY-MM-DD')
            }
            this.$http
                .post(`${this.apiPath}/bank_cards/get`, { accounts_id: this.account.id }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    var bank_cards = res.data
                    var AliasPanPath = ''
                    for (var i = 0; i < bank_cards.length; i++) {
                        var bank_card = bank_cards[i]
                        AliasPanPath += `${bank_card.alias_pan}/`
                        if (bank_card.payment_account_reference) {
                            AliasPanPath += `${bank_card.payment_account_reference}/`
                        }
                    }
                    this.$http
                        .get(`${this.omsApiPath}/payments/get/${this.omsApiKey}/0/0/4:desc/${succeeded}/${failed}/${startDate}/${endDate}/${AliasPanPath}`)
                        .then((res) => {
                            var payments = res.data.payload
                            for (var i = 0; i < payments.length; i++) {
                                var payment = payments[i]
                                payment.BankCard.label = this.$formatLabel(payment.BankCard.label)
                                payment.Payments.amount = this.$formatAmount(payment.Payments.amount, payment.Payments.currencies_code)
                                payment.Payments.created = this.$formatDate(payment.Payments.created, this.account.locales_id, Intl.DateTimeFormat().resolvedOptions().timeZone)
                                payment.Payments.updated = this.$formatDate(payment.Payments.updated, this.account.locales_id, Intl.DateTimeFormat().resolvedOptions().timeZone)
                            }
                            this.getPendingPayments(AliasPanPath)
                            this.payments = payments
                            this.selectedDate = `${moment(startDate).format('DD/MM/YYYY')} - ${moment(endDate).format('DD/MM/YYYY')}`
                            this.setLoader(false)
                        })
                        .catch((err) => {
                            this.setErrorFromServer(err.message)
                            this.setLoader(false)
                        })
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                    this.setLoader(false)
                })
        },
        getPendingPayments(AliasPanPath) {
            this.$http
                .get(`${this.omsApiPath}/payments/get_failed_summaries/${this.omsApiKey}/0/0/${AliasPanPath}`)
                .then((res) => {
                    var pendingPayments = res.data.payload
                    var total_pending_payments_amount = 0
                    for (let i = 0; i < pendingPayments.length; i++) {
                        const payment = pendingPayments[i]
                        total_pending_payments_amount += payment.total_amount
                    }
                    this.total_pending_payments_amount = total_pending_payments_amount
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                    this.setLoader(false)
                })
        },
        filterByDate(when) {
            this.payments = null
            this.getPayments(when.startDate, when.endDate, this.succeeded, this.failed)
        },
        getReceipt(short_id) {
            this.$http
                .post(`${this.omsApiPath}/payments/get_info`, {short_id}, {
                    headers: {
                        "api-key": this.omsApiKey
                    }
                })
                .then((res) => {
                    var info = res.data
                    for (var i = 0; i < info.tickets.length; i++) {
                        var ticket = info.tickets[i]
                        if (ticket.first_validation_transit_data) {
                            var first_validation_transit_data = []
                            for (const [key, val] of Object.entries(ticket.first_validation_transit_data)) {
                                first_validation_transit_data.push({key, val})
                            }
                            ticket.first_validation_transit_data = first_validation_transit_data
                        }
                        if (ticket.last_validation_transit_data) {
                            var last_validation_transit_data = []
                            for (const [key, val] of Object.entries(ticket.last_validation_transit_data)) {
                                last_validation_transit_data.push({key, val})
                            }
                            ticket.last_validation_transit_data = last_validation_transit_data
                        }
                    }
                    this.receipt = info
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        },
        setupPdf() {
            return new Promise((resolve) => {
                html2pdf(document.getElementById('receipt'), {
                    margin: 1,
                    filename: `${this.$t('Dashboard.Payments.Modals.PaymentReceipt.labels.receipt')}-${this.receipt.payment.short_id}.pdf`
                })
                resolve()
            })
            
        }, 
        downloadReceipt() {
            this.setupPdf()
        }
    },
    created() {
        this.getPayments(null, null, this.succeeded, this.failed)
    }
}
</script>